import { htmlSafe } from '@ember/template';
import { isPresent } from '@ember/utils';
import { action } from '@ember/object';
import Component from '@glimmer/component';

interface IBvSplitPanePaneArgs {
  isFirst: boolean;
  isVertical?: boolean;
  initialSize?: number | string;
  size?: number | string;
  registerWithParent: (isFirst: boolean, el: HTMLElement) => void;
  unregisterWithParent: (isFirst: boolean) => void;
}

export default class BvSplitPanePane extends Component<IBvSplitPanePaneArgs> {
  get isFirst() {
    return this.args.isFirst ?? true;
  }

  get style() {
    const { isVertical = true, initialSize, size } = this.args;
    const actualSize = size ?? initialSize;
    if (isPresent(actualSize)) {
      const displayStyle = isVertical ? '' : 'display:flex;';
      return htmlSafe(`flex:none;${displayStyle}`);
    }
    return undefined;
  }

  get resizerStyle() {
    const { isVertical = true, initialSize, size } = this.args;
    let actualSize = size ?? initialSize;
    if (isPresent(actualSize)) {
      const sizeStyle = `${isVertical ? 'width:' : 'height:'}${actualSize}${
        typeof actualSize === 'number' ? 'px' : ''
      };`;
      return htmlSafe(`${sizeStyle}`);
    }
    return undefined;
  }

  @action
  handleDidInsert(el: HTMLElement) {
    // run next to avoid changing the component during a render iteration
    this.args.registerWithParent?.(this.isFirst, el);
  }

  willDestroy() {
    this.args.unregisterWithParent?.(this.isFirst);
  }
}
